/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChatLastReadEntry } from './ChatLastReadEntry';
import {
    ChatLastReadEntryFromJSON,
    ChatLastReadEntryFromJSONTyped,
    ChatLastReadEntryToJSON,
} from './ChatLastReadEntry';

/**
 * 
 * @export
 * @interface ChatLastRead
 */
export interface ChatLastRead {
    /**
     * 
     * @type {string}
     * @memberof ChatLastRead
     */
    user_id?: string;
    /**
     * 
     * @type {Array<ChatLastReadEntry>}
     * @memberof ChatLastRead
     */
    rooms?: Array<ChatLastReadEntry>;
}

/**
 * Check if a given object implements the ChatLastRead interface.
 */
export function instanceOfChatLastRead(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChatLastReadFromJSON(json: any): ChatLastRead {
    return ChatLastReadFromJSONTyped(json, false);
}

export function ChatLastReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatLastRead {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
        'rooms': !exists(json, 'rooms') ? undefined : ((json['rooms'] as Array<any>).map(ChatLastReadEntryFromJSON)),
    };
}

export function ChatLastReadToJSON(value?: ChatLastRead | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.user_id,
        'rooms': value.rooms === undefined ? undefined : ((value.rooms as Array<any>).map(ChatLastReadEntryToJSON)),
    };
}

